import { Chart } from 'chart.js';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Title } from '@angular/platform-browser';
import { ChartConfiguration, ChartData, ChartType, registerables } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
import { UsageReportingService, UsageReportingData } from './usage-reporting.service';

import zoomPlugin from 'chartjs-plugin-zoom';
// The candlestick graphs are not shown, but they were hard to figure out, so I've left the code
//  in, but commented-out
// import { CandlestickController, CandlestickElement, OhlcController, OhlcElement } from 'chartjs-chart-financial';

Chart.register(...registerables);
// Chart.register(OhlcElement, OhlcController, CandlestickElement, CandlestickController, zoomPlugin);
Chart.register(zoomPlugin);

@Component({
  selector: 'naas-usage-reporting',
  templateUrl: './usage-reporting.component.html',
  styleUrls: ['./usage-reporting.component.scss'],
  imports: [BaseChartDirective, CommonModule],
})
export class UsageReportingComponent implements OnInit {
  data: UsageReportingData = {
    message: '',
    scope: '',
    customer: '',
    raw_usage: {
      annual_unique_logins: 0,
      hours: {
        labels: [],
        dataPoints: [],
      },
      notebook_types: {
        labels: [],
        dataPoints: [],
      },
      course_summary: {
        name: [],
        unique_ids: [],
      },
      course_notebooks: [],
      course_notebooks_labels: {},
      // course_whiskers: {
      //   labels: [],
      //   data: [],
      // },
      monthly_labels: [],
      monthly_displays: [],
      monthly_total_logins: {
        name: '',
        dataPoints: [],
      },
      monthly_unique_logins: {
        name: '',
        dataPoints: [],
      },
      monthly_nb_starts: {
        name: '',
        dataPoints: [],
      },
    },
  };

  public lineChartType: ChartType = 'line';
  public doughnutChartType: ChartType = 'doughnut';
  public barChartType: ChartType = 'bar';

  // public candlestickChartType: ChartType = 'candlestick';

  public monthlyChartOptions: ChartConfiguration['options'] = {
    elements: {
      line: {
        tension: 0.25,
      },
    },
    scales: {
      // We use this empty structure as a placeholder for dynamic theming.
      y: {
        position: 'left',
      },
    },
    plugins: {
      legend: { display: true },
    },
  };
  public monthlyChartData: ChartConfiguration['data'] = {
    datasets: [],
    labels: [],
  };
  public timeOfDayChartOptions: ChartConfiguration['options'] = {
    scales: {
      x: {
        grid: { display: false },
      },
      y: {
        display: false,
      },
    },
    plugins: {
      tooltip: { enabled: false },
    },
  };
  public timeOfDayChartData: ChartConfiguration['data'] = {
    datasets: [],
    labels: [],
  };
  public doughnutChartOptions: ChartConfiguration['options'] = {
    plugins: {
      legend: { position: 'right' },
    },
    responsive: true,
    maintainAspectRatio: true,
  };
  public doughnutChartData: ChartData<'doughnut'> = {
    labels: [],
    datasets: [],
  };

  // I know, it should be a defined type, but I don't want to spend time on it right now
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public sortedDonutTableData: any[] = [];

  public usersPerCourseChartOptions: ChartConfiguration['options'] = {
    maintainAspectRatio: true,
    plugins: {
      zoom: {
        limits: {
          y: {
            min: 0,
            max: 'original',
          },
        },
        pan: {
          enabled: true,
        },
        zoom: {
          wheel: {
            enabled: true,
          },

          pinch: {
            enabled: true,
          },
          mode: 'xy',
        },
      },
    },
  };
  public usersPerCourseChartData: ChartConfiguration['data'] = {
    datasets: [],
    labels: [],
  };
  public notebooksPerCourseChartOptions: ChartConfiguration['options'] = {
    maintainAspectRatio: true,
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
      },
    },
    plugins: {
      zoom: {
        limits: {
          y: {
            min: 0,
            max: 'original',
          },
        },
        pan: {
          enabled: true,
        },
        zoom: {
          wheel: {
            enabled: true,
          },

          pinch: {
            enabled: true,
          },
          mode: 'xy',
        },
      },
    },
  };
  public notebooksPerCourseChartData: ChartConfiguration['data'] = {
    datasets: [],
    labels: [],
  };
  // public courseWiskerChartOptions: ChartConfiguration['options'] = {
  //   responsive: true,
  //   scales: {
  //     x: {
  //       type: 'linear',
  //       position: 'bottom',
  //     },
  //     y: {
  //       title: {
  //         display: true,
  //         text: 'Cumulative time in minutes',
  //       },
  //     },
  //   },
  //   plugins: {
  //     zoom: {
  //       limits: {
  //         x: {
  //           min: 0,
  //           max: 'original',
  //         },
  //         y: {
  //           min: 0,
  //           max: 'original',
  //         },
  //       },
  //       pan: {
  //         enabled: true,
  //       },
  //       zoom: {
  //         wheel: {
  //           enabled: true,
  //         },

  //         pinch: {
  //           enabled: true,
  //         },
  //         mode: 'xy',
  //       },
  //     },
  //   },
  // };

  // public courseWiskerChartData: ChartData<'candlestick'> = {
  //   datasets: [],
  // };
  public totalCourseCount: number = 0;
  public totalUniqueUsers: number = 0;
  public isCustomerAdmin: boolean = false;
  public scope: string = '';
  public customer: string = '';
  public startDate: string = '';
  public endDate: string = '';

  constructor(
    public httpClient: HttpClient,
    private usageReportingService: UsageReportingService,
    private route: ActivatedRoute,
  ) {
    const titleService = inject(Title);
    const pageTitle = 'Usage Reporting - Noteable';
    titleService.setTitle(pageTitle);

    const myH1 = document.querySelector('h1');
    if (myH1) {
      myH1.textContent = pageTitle;
    }
  }

  ngOnInit() {
    this.route.data.subscribe(data => {
      this.data = data.usageData;
      this.startDate = this.data.raw_usage.monthly_displays[0];
      this.endDate = this.data.raw_usage.monthly_displays[11];

      const log_trigger_value = 1000;

      if (
        this.monthlyChartOptions?.scales?.y &&
        (Math.max(...this.data.raw_usage.monthly_total_logins.dataPoints) > log_trigger_value ||
          Math.max(...this.data.raw_usage.monthly_unique_logins.dataPoints) > log_trigger_value ||
          Math.max(...this.data.raw_usage.monthly_nb_starts.dataPoints) > log_trigger_value)
      ) {
        this.monthlyChartOptions.scales.y.type = 'logarithmic';
      }

      this.monthlyChartData = {
        labels: this.data.raw_usage.monthly_displays,
        datasets: [
          {
            data: this.data.raw_usage.monthly_total_logins.dataPoints,
            label: this.data.raw_usage.monthly_total_logins.name,
            backgroundColor: 'rgba(148,159,177,0.2)',
            borderColor: 'rgba(148,159,177,1)',
            pointBackgroundColor: 'rgba(148,159,177,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(148,159,177,0.8)',
            fill: 'origin',
          },
          {
            data: this.data.raw_usage.monthly_unique_logins.dataPoints,
            label: this.data.raw_usage.monthly_unique_logins.name,
            backgroundColor: 'rgba(77,83,96,0.2)',
            borderColor: 'rgba(77,83,96,1)',
            pointBackgroundColor: 'rgba(77,83,96,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(77,83,96,1)',
            fill: 'origin',
          },
          {
            data: this.data.raw_usage.monthly_nb_starts.dataPoints,
            label: this.data.raw_usage.monthly_nb_starts.name,
            backgroundColor: 'rgba(255,0,0,0.3)',
            borderColor: 'red',
            pointBackgroundColor: 'rgba(148,159,177,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(148,159,177,0.8)',
            fill: 'origin',
          },
        ],
      };
      this.timeOfDayChartData = {
        labels: this.data.raw_usage.hours.labels,
        datasets: [{ data: this.data.raw_usage.hours.dataPoints, label: 'Start time [hour]' }],
      };

      // The donut details
      this.doughnutChartData = {
        labels: this.data.raw_usage.notebook_types.labels,
        datasets: [
          {
            data: this.data.raw_usage.notebook_types.dataPoints,
          },
        ],
      };
      this.prepareDonutDataTable();

      // Not including this for now: lets keep the Y-Axis for "users per course" and "notebooks per course, stacked"
      //  the same
      // if (
      //   this.usersPerCourseChartOptions &&
      //   Math.max(...this.data.raw_usage.course_summary.unique_ids) > log_trigger_value
      // ) {
      //   this.usersPerCourseChartOptions.scales = {
      //     y: {
      //       type: 'logarithmic',
      //     },
      //   };
      // }

      this.usersPerCourseChartData = {
        labels: this.data.raw_usage.course_summary.name,
        datasets: [{ data: this.data.raw_usage.course_summary.unique_ids, label: 'Unique users per course' }],
      };

      this.notebooksPerCourseChartData = {
        labels: this.data.raw_usage.course_notebooks_labels.name,
        datasets: [],
      };
      this.data.raw_usage.course_notebooks.forEach(item => {
        this.notebooksPerCourseChartData.datasets.push({
          data: item.dataPoints,
          label: item.label,
        });
      });
      // this.courseWiskerChartData = {
      //   labels: this.data.raw_usage.annual_usage.course_whiskers.labels,
      //   datasets: [
      //     {
      //       label:
      //         'Sum of runtime for all notebooks on a course (still need to figure how to tag courses in the chart)',
      //       data: this.data.raw_usage.annual_usage.course_whiskers.data,
      //     },
      //   ],
      // };

      this.totalCourseCount = this.data.raw_usage.course_summary.name.length;
      this.totalUniqueUsers = this.data.raw_usage.annual_unique_logins;
      if (this.data.scope === 'isCustomerAdmin') {
        this.isCustomerAdmin = true;
      }

      this.scope = this.data.scope;
      this.customer = this.data.customer;
    });
  }

  prepareDonutDataTable(): void {
    this.sortedDonutTableData = [];
    if (!this.doughnutChartData.labels) return;

    for (let i = 0; i < this.doughnutChartData.labels.length; i++) {
      this.sortedDonutTableData.push({
        label: this.doughnutChartData.labels[i],
        value: this.doughnutChartData.datasets[0].data[i].toString().replace(/\B(?=(?:\d{3})+)$/g, ','),
      });
    }
    this.sortedDonutTableData.sort((a, b) => b.value - a.value);
  }
}
